<div class="snack-dialog-container" (click)="closeSnackBar()">
    <div class="snackbar-dialog-title text-white">
        {{ type }}
    </div>
    <div class="snackbar-dialog-content">
        <span>{{ message }}</span>
    </div>
</div>